import GroupPostsDashboard from '@/components/Groups/GroupPostsDashboard/GroupPostsDashboard'

// TODO: To refactor at a later date
export const PostsPage = () => {
  return <GroupPostsDashboard />
}
